import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as PettyCashActions from './petty-cash.actions';
import { PettyCashService } from '../../../../core/services/gse/petty-cash.service';
import { ToastService } from '../../../../core/services/toast.service';

@Injectable()
export class PettyCashEffects {
  private actions$ = inject(Actions);
  private pettyCashService = inject(PettyCashService);
  private toastService = inject(ToastService);

  loadBalance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PettyCashActions.loadPettyCashBalance),
      switchMap(() =>
        this.pettyCashService.getPettyCashBalanceResponse().pipe(
          map((response) =>
            PettyCashActions.loadPettyCashBalanceSuccess({
              response: response.body || { data: { balance: 0 } },
            })
          ),
          catchError((error) =>
            of(
              PettyCashActions.loadPettyCashBalanceFailure({
                error: error.error.message || 'Failed to load petty cash balance',
              })
            )
          )
        )
      )
    )
  );

  loadBalanceFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PettyCashActions.loadPettyCashBalanceFailure),
        tap(({ error }) => {
          this.toastService.showError('Error', error);
        })
      ),
    { dispatch: false }
  );

  updateBalance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PettyCashActions.updatePettyCashBalance),
      switchMap(({ body }) =>
        this.pettyCashService.updatePettyCashBalance(body).pipe(
          map((response) =>
            PettyCashActions.updatePettyCashBalanceSuccess({
              response: response.body || { message: 'Updated successfully' },
            })
          ),
          catchError((error) =>
            of(
              PettyCashActions.updatePettyCashBalanceFailure({
                error: error.error.message || 'Failed to update petty cash balance',
              })
            )
          )
        )
      )
    )
  );

  updateBalanceSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PettyCashActions.updatePettyCashBalanceSuccess),
        tap(({ response }) => {
          this.toastService.showSuccess('Success', response.message);
        })
      ),
    { dispatch: false }
  );

  updateBalanceFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PettyCashActions.updatePettyCashBalanceFailure),
        tap(({ error }) => {
          this.toastService.showError('Error', error);
        })
      ),
    { dispatch: false }
  );
}
